<template>
  <div
    :id="index"
    class="question-item"
    :class="{
      sticky:
        item.is_sticky ||
        isQuestionOpen(item.original_index) ||
        hasInnerLevelOpen(item.original_index),
      active: !active.toString().includes('_')
        ? active.toString() == index
        : active.toString().startsWith(index) &&
          active.toString().includes(`_${childIndex}`),
    }"
  >
    <faq-item-header
      :title="item.title"
      :subtitle="item.subtitle"
      :active="active"
      :sticky="item.is_sticky"
      @is-active="activeHandler(index)"
    />

    <div v-if="item.editor" class="question-body" v-html="item.editor"></div>

    <div v-if="item.inner_level" class="question-body">
      <div
        v-for="(inner, i) in item.inner_level"
        :key="i"
        :id="`${index}_${i}`"
        class="question-item question-item-inner"
        :class="{
          active:
            active == `${index}_${i}`
              ? 'active'
              : '' || isQuestionOpen(inner.original_index),
        }"
      >
        <faq-item-header
          :title="item.title"
          :subtitle="item.subtitle"
          :isChild="true"
          :inner="inner.inner_title"
          @is-active="activeHandler(`${index}_${i}`, i)"
        />
        <div class="question-body" v-html="inner.editor"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqItemHeader from "./FaqItemHeader.vue";

export default {
  name: "FaqItem",
  components: { FaqItemHeader },
  props: ["item", "index", "active", "openQuestions"],
  emits: ["item-click-handler"],
  data() {
    return {
      childIndex: null,
    };
  },
  methods: {
    activeHandler(id, i) {
      if (i === 0 || i) {
        this.childIndex = i;
      }
      this.$emit("item-click-handler", id);
    },
    isQuestionOpen(index) {
      console.log(this.openQuestions, index);

      return this.openQuestions.includes(index);
    },
    hasInnerLevelOpen(index) {
      return this.openQuestions.find(
        (question) =>
          question.toString().includes("_") && question.startsWith(index)
      );
    },
  },
};
</script>
